const baseUrl =
	process.env.NODE_ENV === 'production'
		? 'http://3.85.16.32:9000'
		: 'http://localhost:9000'
		// 'http://54.167.205.240:9000'

export default baseUrl;
